import { render } from "./ReturnOrderComponent.vue?vue&type=template&id=5cd4ce9e"
import script from "./ReturnOrderComponent.vue?vue&type=script&lang=js"
export * from "./ReturnOrderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/returnOrders/ReturnOrderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cd4ce9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cd4ce9e', __exports__)) {
    api.reload('5cd4ce9e', __exports__)
  }
  
  module.hot.accept("./ReturnOrderComponent.vue?vue&type=template&id=5cd4ce9e", () => {
    api.rerender('5cd4ce9e', render)
  })

}


export default __exports__